import { darkTheme } from './dark.theme'
import { defaultTheme } from './default.theme'

export const themes = {
  default: defaultTheme,
  dark: darkTheme
}
